import { logger } from '../../../../utils/common/logger'
import { ISubscriberServiceAdapter } from '../adapter'
import { LoginService } from '../loginradius/services/login-service'

interface IWindow extends Window {
    Sailthru: {
        integration: (eventName: string, options: any) => {}
    }
}

declare let window: IWindow

export class RegistrationSuccess {
    public static DOM = {
        attrs: {
            registrationSuccessContinueButton: 'data-registration-success-continue'
        },
        class: {
            pageRegistrationSuccess: 'page-registration-success'
        },
        selectors: {
            offer: '#registration-success__offer'
        }
    }
    private subService: ISubscriberServiceAdapter

    constructor(subscriberService: ISubscriberServiceAdapter) {
        this.subService = subscriberService
    }

    public init() {
        const registrationSuccessPage = document.querySelector
            (`.${RegistrationSuccess.DOM.class.pageRegistrationSuccess}`)

        if (registrationSuccessPage) {
            const continueButton = document.querySelector(
                `[${RegistrationSuccess.DOM.attrs.registrationSuccessContinueButton}]`
            ) as HTMLButtonElement

            this.showOffer()

            const redirect = LoginService.getRedirectUrl(location.origin)
            if (continueButton) {
                continueButton.addEventListener('click', () => {
                    logger('info', 'Registration success - redirecting')
                    location.replace(redirect)
                })
            }
        }
    }

    private showOffer() {
        const offerContainer: HTMLDivElement = document.querySelector(RegistrationSuccess.DOM.selectors.offer)
        const offerId = offerContainer ? offerContainer.dataset.registrationSuccess__offer_id : undefined
        const templateId = offerContainer ? offerContainer.dataset.registrationSuccess__template_id : undefined

        if (offerId && templateId) {
            // Show Piano offer
            this.subService.showOffer(
                offerId,
                templateId,
                'inline',
                RegistrationSuccess.DOM.selectors.offer
            )
        }
    }
}
